import { jsx as _jsx } from "react/jsx-runtime";
import Text from '@amzn/meridian/text';
import { rio } from '@amzn/rio-design-tokens';
import styled from '@emotion/styled';
import { PillButton } from 'src/common/buttons';
import { ScrollableRow } from 'src/common/styled';
const PillText = styled(Text) `
  color: ${({ theme }) => theme.mode === 'dark' ? rio.semantic.color.background.primary : rio.semantic.color.link.default};
`;
const PillCarouselRow = styled(ScrollableRow) `
  && {
    padding: 0 12px;
    margin: 0 -12px !important;
  }
`;
export const RufusPillCarousel = ({ pills, setSelectedQuery, widgetRef }) => {
    const handlePillClick = (questionText) => {
        setSelectedQuery(questionText);
        // Scroll to the top of widget in vertical manner if widget is out of viewport on pill click.
        if (widgetRef === null || widgetRef === void 0 ? void 0 : widgetRef.current) {
            const rect = widgetRef.current.getBoundingClientRect();
            const isInViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;
            if (!isInViewport) {
                widgetRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    };
    return pills ? (_jsx(PillCarouselRow, { spacing: "300", children: pills.map((pill) => (_jsx(PillButton, { onClick: () => handlePillClick(pill.questionText), children: _jsx(PillText, { type: "b200", children: pill.questionText }) }, pill.questionText))) })) : null;
};
